import React from "react";

function Error() {
  return (
    <div>
      <h2>Page Doesn't Exist</h2>
    </div>
  );
}

export default Error;
